<div class="cm-app-container" [style.background]="appBackgroundColor">
    @if (!$shouldHideNavigation()) {
        <cm-side-navigation></cm-side-navigation>
    }
    <div class="cm-main-container" [class.cm-full-width]="$shouldHideNavigation()">
        <router-outlet></router-outlet>
    </div>
    @if (startingScreen.$visible()) {
        <cm-onboarding-dialog></cm-onboarding-dialog>
    }
    <cm-background-operation-list></cm-background-operation-list>
</div>
